import { callApi, getApi } from '../../../api/call';

async function authedPost(path, body) {
  const { data } = await callApi(path, body);
  return data;
}

export async function sendEmployeeInvite({
  email,
  role,
  companyId,
  ownerId,
  inviterName,
  locationIds,
}) {
  return authedPost(`/api/companies/${encodeURIComponent(companyId)}/invites/employees`, {
    email,
    role,
    companyId,
    ownerId,
    inviterName,
    locationIds: Array.isArray(locationIds) ? locationIds : [],
  });
}

export async function acceptEmployeeInvite({ token, firstName, lastName, phone }) {
  return authedPost('/api/invites/employees/accept', { token, firstName, lastName, phone });
}

export async function listPendingInvites({ companyId }) {
  const data = await authedPost(
    `/api/companies/${encodeURIComponent(companyId)}/invites/employees/list`,
    { status: 'pending' }
  );
  return data.invites || [];
}

export async function resendInvite({ companyId, token }) {
  return authedPost(
    `/api/companies/${encodeURIComponent(companyId)}/invites/employees/${encodeURIComponent(token)}/resend`,
    {}
  );
}

export async function cancelInvite({ companyId, token }) {
  return authedPost(
    `/api/companies/${encodeURIComponent(companyId)}/invites/employees/${encodeURIComponent(token)}/cancel`,
    {}
  );
}

export async function getInviteByToken(token) {
  return getApi(`/api/invites/employees?token=${encodeURIComponent(token)}`);
}

export async function sendClientInvite({ email, companyId, ownerId, inviterName }) {
  return authedPost(`/api/companies/${encodeURIComponent(companyId)}/invites/clients`, {
    email,
    companyId,
    ownerId,
    inviterName,
  });
}

export async function acceptClientInvite({ token, firstName, lastName, phone }) {
  return authedPost('/api/invites/clients/accept', { token, firstName, lastName, phone });
}

export async function getClientInviteByToken(token) {
  return getApi(`/api/invites/clients?token=${encodeURIComponent(token)}`);
}

export async function listPendingClientInvites({ companyId }) {
  const data = await authedPost(
    `/api/companies/${encodeURIComponent(companyId)}/invites/clients/list`,
    { status: 'pending' }
  );
  return data.invites || [];
}

export async function resendClientInviteApi({ companyId, token }) {
  return authedPost(
    `/api/companies/${encodeURIComponent(companyId)}/invites/clients/${encodeURIComponent(token)}/resend`,
    {}
  );
}
